<template>
    <!-- custom filter scenario 9 -->
    <!-- customer filter (admin only) -->

    <div class="custom-filter-container pr-20">
        <div class="ml-8 mb-12">
            <!-- custom filter toggle button -->
            <el-button
            color="#0D3937"
            class="toggle-button"
            :disabled="$store.state.auth.user == null || !$store.state.auth.user.is_admin"
            @click="displayFilter = !displayFilter"
            >
                <svg class="svg-left width-20 height-20">
                    <use href="@/assets/svg/newSvgIcon.svg#customerFilterButton"></use>
                </svg>
                <span class="moderat-white-bold m-l-10 m-r-10">Custom filter</span>
                <svg v-if="displayFilter" class="svg-right width-20 height-20">
                    <use href="@/assets/svg/newSvgIcon.svg#customFilterArrowClose"></use>
                </svg>
                <svg v-else class="svg-right width-20 height-20">
                    <use href="@/assets/svg/newSvgIcon.svg#customFilterArrowOpen"></use>
                </svg>
            </el-button>
        </div>

        <!-- Custom filter -->
        <el-row v-if="displayFilter">
            <div 
            class="custom-filter-container-wrapper row y-center m-0 mt-2 mb-12 mx-2 p-2 bg-me-primary border-color-light rounded-4 width-100-p"
            >
                <el-form :label-position="`top`" class="custom-filter-form">
                <el-space
                    class="custom-filter-space"
                    fill
                    >

                    <!-- customer list (admin only) -->
                    <el-row gutter="20">
                        <el-col 
                            :span="$vuetify.display.width > 1280 ? 10 : 24" 
                            :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'" 
                        >
                            <el-form-item
                                class="custom-filter-item label-style"
                                prop="customer"
                                label="Customer"
                            >
                                <!-- customer select -->
                                <div>
                                    <el-select 
                                        v-model="filter.customer_id" 
                                        placeholder="Select Customer"  
                                        class="custom-filter-select"
                                        clearable
                                        >
                                        <el-option
                                            v-for="item in customers"
                                            :key="item.id"
                                            :label="item.full_name"
                                            :value="item.id"
                                            >
                                            <span>{{ item.full_name }}</span>
                                            <!-- <span>{{ item.phone }}</span> -->
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-space>
                </el-form>
                <el-row gutter="20" class="custom-filter-button-container float-right mb-20">
                    <el-col :span="24" :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'">
                        
                        <el-button
                            v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
                            @click="applyFilter"
                            class="custom-filter-button-apply"
                        >
                            <svg class="width-111 height-40">
                            <use href="@/assets/svg/newSvgIcon.svg#customFilterApplyButton"></use>
                            </svg>
                        </el-button>
                        <el-button
                            v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
                            @click="resetFilter"
                            class="custom-filter-button-reset"
                        >
                            <svg class="width-112 height-40">
                            <use href="@/assets/svg/newSvgIcon.svg#customFilterResetButton"></use>
                            </svg>
                        </el-button>
                        </el-col>
                </el-row>
            </div>
        </el-row>
    </div>
</template>

<script>
import UserService from "../../../services/user.service";
import { shorterLabel, customersForAccess } from "./common-tools";

export default {
    props: {
    },
    data() {
        return {
            displayFilter: false, // toggle display of custom filter
            customers: [],
            loading: false,
            filter: {
                customer_id: null,
            },
        }
    },
    watch: {
        'filter.customer_id': function (newValue) {
            // Convert empty string to null when customer is cleared
            if (newValue === '') {
                this.filter.customer_id = null;
            }
        },
    },

    async mounted() {
        if (
            this.$store.state.auth.user != null &&
            this.$store.state.auth.user.is_admin
        ) {
            this.fetchCustomerData();
        }
        else {
            this.customers = [];
            this.filter.customer_id = null;
        }
    },

    methods: {
        // change label to shorter label for fixed button length
        shortLabel(inputLabel,length,MaxLength,additional) {
        let label = shorterLabel(inputLabel,length,MaxLength,additional);
        return label;
        },


        async fetchCustomerData() {
            this.loading = true;
            await UserService.getCustomers(null)
                .then(
                (response) => {
                    if (!response || !response.data || !response.data.customers) {
                        this.customers = [];
                    } else {
                        this.customers = customersForAccess(response.data.customers, this.$store.state.auth.user);
                    }
                },
                (error) => {
                    this.loading = false;
                    console.log(error.message);
                    if (error.response.status == 401) {
                    this.$router.push({
                        path: "/",
                    });
                    }
                }
                )
                .catch((error) => {
                this.loading = false;
                console.log(error.message);
                if (error.response.status == 401) {
                    this.$router.push({
                    path: "/",
                    });
                }
                })
                .finally(() => (this.loading = false));
        },

        applyFilter() {
            this.$emit("filterHandle", this.filter);
        },

        async resetFilter() {
            this.filter = {
                customer_id: null,
            };
            this.$emit("filterHandle", {customer_id: null});
        },
    },
}
</script>

